import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

const HomeEdRegistrationListPage = lazy(() => import('src/pages/home-ed-registration-admin/list'));
const HomeEdRegistrationDetailsPage = lazy(() =>
  import('src/pages/home-ed-registration-admin/details')
);

const guardedListPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_FACILITATOR, ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdRegistrationListPage />
  </RoleBasedGuard>
);

const guardedDetailsPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_FACILITATOR, ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdRegistrationDetailsPage />
  </RoleBasedGuard>
);

export const homeEdRegistrationAdminRoutes = [
  {
    path: 'home-ed-registration',
    children: [
      { element: guardedListPage, index: true },
      {
        path: ':registrationId',
        children: [{ element: guardedDetailsPage, index: true }],
      },
    ],
  },
];
